import React from 'react';
import { NavLink } from 'react-router';
import { configuration } from 'config/constants';

export const HeaderLogo = () => {
    return <NavLink
        end
        to={configuration.sgMarketsUrl}
        className="navbar-title-link"
    >
        <div className="navbar-logo">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0" y="0" width="100%" height="50%" fill="#E60028"></rect>
                <rect x="0" y="50%" width="100%" height="50%" fill="#1D1D1B"></rect>
                <rect x="17%" y="46.5%" width="65%" height="7%" fill="white"></rect>
            </svg>
        </div>
        <div className="navbar-title-divider"></div>
        <div className="navbar-service-name">SG MARKETS</div>
    </NavLink>;
};